import { useEffect, useState } from "react"
import { Row, Col, Breadcrumb } from "react-bootstrap"
import { startCase, toLower } from "lodash"
import Link from "next/link"
import SkillHeaderLoader from "./SkillHeaderLoader"
import { SkillHeaderInfoCol } from "../styled/SkillStyled"
import LoadMoreButton from "@modules/Common/styled/LoadMore"
import { PublicSkillQuery, StudentSkillQuery, useStudentSkillQuery } from "@generated/graphql"

interface ISkillDetail {
  slug: string,
  skill?: PublicSkillQuery["publicSkill"]
}

export default function SkillDetail({ slug, skill }: ISkillDetail) {
  const [localSkill, setLocalSkill] = useState<StudentSkillQuery["studentSkill"] | PublicSkillQuery["publicSkill"] | undefined>(skill)
  const { data: skillData, loading: skillDataLoading } = useStudentSkillQuery({
    variables: {
      slug: slug
    },
    skip: !!skill,
    notifyOnNetworkStatusChange: true,
  })

  useEffect(() => {
    if (skillData?.studentSkill) {
      setLocalSkill(skillData?.studentSkill)
    }
  }, [skillData])

  if (localSkill === undefined && skillDataLoading) {
    return (
      <Row>
        <SkillHeaderLoader />
      </Row>
    )
  }

  return (
    <>
      <Row>
        <Col xs={{ offset: 1 }} md={{ offset: 1 }}>
          <Breadcrumb>
            <Breadcrumb.Item linkAs={Link} href="/dashboard">Home</Breadcrumb.Item>
            <Breadcrumb.Item linkAs={Link} href="/skills">Skills</Breadcrumb.Item>
            <Breadcrumb.Item linkAs={Link} href={`/skills/${localSkill?.slug}`}>{localSkill?.name}</Breadcrumb.Item>
          </Breadcrumb>
        </Col>
      </Row>
      <Row>
        <Col lg={{ span: 3, offset: 1 }} md={{ span: 3, offset: 1 }} sm={{ span: 8, offset: 2 }} xs={{ span: 8, offset: 2 }}>
          <div>
            <img src={localSkill?.featuredImage || "/assets/img/logo.png"} style={{ maxHeight: "60%", maxWidth: "60%" }} />
          </div>
        </Col>
        <SkillHeaderInfoCol lg={6} md={7} style={{ position: "relative" }}>
          <div style={{ top: "20%" }}>
            <h3 style={{ fontWeight: "bold", fontSize: "2em" }}>{startCase(toLower(slug?.replace(" ", "")))}</h3>
            {localSkill?.description && localSkill?.description !== "<p><br></p>" &&
              <div style={{ textAlign: "left" }} dangerouslySetInnerHTML={{ __html: localSkill?.description }} />
            }
            {localSkill?.bundle &&
              <LoadMoreButton onClick={() => {
                window.open(localSkill?.bundle!!, "_blank")
              }}>
                BUY KIT
              </LoadMoreButton>}
          </div>
        </SkillHeaderInfoCol>
      </Row>
    </>
  )
}
